import Vue from "vue";
import formatToSiteLocalDateTime from "./formatToSiteLocalDateTime";

const FormatToSiteLocalDateTimePlugin = {
  install() {
    Vue.prototype.formatToSiteLocalDateTime = (dateString: string, formatString: string) => {
      return formatToSiteLocalDateTime(dateString, formatString);
    };
  }
};

export default FormatToSiteLocalDateTimePlugin;
